import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './UpdateKeywordVisibility.css'
import { updateGraphNodes, touchNodeVisibility } from '../redux/keywords'
import KeywordGraphPicker from '../components/KeywordGraphPicker'

class UpdateKeywordVisibility extends Component {
  state = {
    updatedNodes: {},
    saving: false
  }
  updateNodes = updatedNodes => {
    this.setState({ updatedNodes })
  }
  onSave = () => {
    this.setState({ saving: true })
    this.props.updateGraphNodes(this.state.updatedNodes)
      .then(() => this.setState({
        saving: false,
        updatedNodes: {}
      }))
  }
  onReset = () => {
    this.setState({ updatedNodes: {} })
  }
  showResolveIndicator = node => {
    return !node.display__updated_at
  }
  render () {
    return (
      <div className={classNames.page}>
        <p className={classNames.note}>
          Keyword groups that are <span className={classNames.selectedExample}>selected</span> will be grouped separately. Keyword groups that are <span className={classNames.excludedExample}>excluded</span> will not be displayed. Use <strong>ind</strong>ex to enter a node rank for custom sorting.
        </p>
        <KeywordGraphPicker
          value={this.state.updatedNodes}
          onChange={this.updateNodes}
          showUpdatedTime='display__updated_at'
          showResolveIndicator={this.showResolveIndicator}
          onClickResolve={this.props.touchNodeVisibility}
          showIndicators
          showGrouping
          showTitles
          headerButtons={[
            <button
              key='reset'
              onClick={this.onReset}
              className={classNames.resetButton}>
              Reset Changes
            </button>,
            <button
              key='save'
              onClick={this.onSave}
              className={classNames.saveButton}
              disabled={this.state.saving}>
              {this.state.saving ? 'Saving…' : 'Save'}
            </button>
          ]}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ config }) => ({
})

const mapDispatchToProps = {
  updateGraphNodes,
  touchNodeVisibility
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateKeywordVisibility)



// WEBPACK FOOTER //
// ./src/pages/UpdateKeywordVisibility.js